import { PredictiveCampaignDto } from "@advanced-sales-technologies/backend-client/models/PredictiveCampaignDto";
import { PredictiveProductDto } from "@advanced-sales-technologies/backend-client/models/PredictiveProductDto";
import { useQuery } from "@tanstack/react-query";

import useSalesyApiClient from "@/hooks/useSalesyApiClient";

export const getAllProductsKey = ["get-all-products"];

export type Product = PredictiveProductDto;
export type Campaign = PredictiveCampaignDto;

export const useGetAllProducts = () => {
  const { apiClient } = useSalesyApiClient();

  return useQuery({
    queryKey: getAllProductsKey,
    queryFn: () => apiClient.predictiveProducts.getAll(),
    refetchOnWindowFocus: false,
  });
};
